import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Services & Utils
import { jobApi } from './services/api';
import { normalizeJobsData } from './utils/jobData';

// Components & Pages
import Home from './pages/Home';
import Insights from './pages/Insights';
import Directory from './pages/Directory';
import Academy from './pages/Academy';
import JobsListing from './pages/JobsListing'; 
import JobDetails from './pages/JobDetails';
import AboutUs from './pages/AboutUs';       
import ContactUs from './pages/ContactUs';   
import Header from './components/Header';
import Footer from './components/Footer';
import Agreement from './pages/Agreement';
// import SpiritualIQGame from './pages/Games';

function App() {
  const [jobsData, setJobsData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setLoading(true);
        // Fetch the master city-keyed object
        const rawData = await jobApi.getAllJobsByCity();
        
        // Normalize it immediately
        const cleanData = normalizeJobsData(rawData);
        
        setJobsData(cleanData);
      } catch (err) {
        console.error("Initialization Error:", err);
        setError("Failed to load job listings. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="animate-pulse text-blue-600 font-bold">Loading India AI Jobs...</div>
      </div>
    );
  }

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-slate-50">
        <Header />
        
        <main className="flex-grow">
          {error ? (
            <div className="p-10 text-center text-red-500">{error}</div>
          ) : (
            <Routes>
              {/* Main Listing */}
              <Route path="/home" element={<Home />} />
              <Route path="/" element={<JobsListing jobsData={jobsData} />} />

              {/* Individual Job Details - Searching from local jobsData */}
              <Route path="/job/:id" element={<JobDetails jobsData={jobsData} />} />

              <Route path="/insights" element={<Insights />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/academy" element={<Academy />} />
              {/* Static Content Pages */}
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/agreement" element={<Agreement />} />
              {/* <Route path="/games" element={<SpiritualIQGame />} /> */}

              {/* Fallback - Redirect unknown URLs to Home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          )}
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;